<template>
  <div class="company-member-bd ub">
    <div class="ub-f1 ubv user-wrap">
      <div class="title">{{ $t('company_member_yglb') }}</div>
      <div class="action-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-button type="warning" round @click="addUser" v-if="funcView.user_add">
              <i class="icon icon-tianjia"></i>
              {{ $t('com_add') }}
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button round :disabled="!tableSelect.length" @click="setUserStatus(true)" v-if="funcView.user_enable">{{ $t('com_enable') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button round :disabled="!tableSelect.length" @click="setUserStatus()" v-if="funcView.user_disabled">{{ $t('com_disable') }}</el-button>
          </el-form-item>
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <el-form-item style="float: right">
            <search-input style="width: 320px" :placeholder="$t('company_member_ygxmdlzhlxdhyx')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd ub-f1">
        <custom-table
          height="100%"
          stripe
          tableCode="portal_user_manage"
          type="radioCheckbox"
          v-model="tableSelect"
          @column="setColumn"
          @sort="sortChange"
          @filter="filterChange"
          @radio="onCurrentRow"
          :data="userList"
        >
          <el-table-column min-width="170" fixed="right">
            <template slot-scope="scope">
              <el-button v-if="funcView.user_edit" size="small" @click="editUser(scope.row.userId)" type="text">{{ $t('com_edit') }}</el-button>
              <el-dropdown>
                <span class="el-dropdown-more">
                  {{ $t('company_member_geng_duo') }}
                  <i class="icon icon-xiala"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="resetPassword(scope.row.userId)" v-if="funcView.user_reset_pwd">{{ $t('company_member_zhong_zhi_mi_ma') }}</el-dropdown-item>
                  <template v-if="funcView.user_disabled">
                    <el-dropdown-item v-if="scope.row.state === 1" @click.native="setItemUserStatus(scope.row.userId)">{{ $t('com_disable') }}</el-dropdown-item>
                  </template>
                  <template v-if="funcView.user_enable">
                    <el-dropdown-item v-if="scope.row.state !== 1" @click.native="setItemUserStatus(scope.row.userId, true)">{{ $t('com_enable') }}</el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </custom-table>
      </div>
      <div class="page-bd">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="changePage"></custom-pagination>
      </div>
    </div>
    <div class="info-wrap ubv" style="width: 430px">
      <div class="name">
        {{ selectedRow.realName }}
      </div>
      <el-tabs v-model="active1" @tab-click="tabClick(true)">
        <el-tab-pane :label="$t('company_member_bu_men')" name="first">
          <div class="ub">
            <div class="ub-f1" style="padding-right: 16px">
              <search-input v-model="search" style="width: 100%" :placeholder="$t('company_member_bmmc')" @fetch="tabClick()"></search-input>
            </div>
            <el-button
              v-if="funcView.user_edit"
              :disabled="!selectedRow.userId"
              style="padding: 0 13px !important"
              type="warning"
              circle
              icon="icon icon-bianji"
              @click="editUser(selectedRow.userId, 2)"
            ></el-button>
          </div>
          <div class="user-department">
            <ul>
              <li v-for="(item, index) in userDepartmentList" :key="index">
                {{ item.bizName }}
              </li>
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('company_member_gang_wei')" name="second">
          <div class="ub">
            <div class="ub-f1" style="padding-right: 16px">
              <search-input v-model="search" style="width: 100%" :placeholder="$t('company_member_gwmc')" @fetch="tabClick()"></search-input>
            </div>
            <el-button
              v-if="funcView.user_edit"
              :disabled="!selectedRow.userId"
              style="padding: 0 13px !important"
              type="warning"
              circle
              icon="icon icon-bianji"
              @click="editUser(selectedRow.userId, 4)"
            ></el-button>
          </div>
          <div class="user-role">
            <ul>
              <li v-for="(item, index) in userRoleList" :key="index">
                {{ item.roleName }}
              </li>
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('company_member_she_bei')" name="third"></el-tab-pane>
      </el-tabs>
      <!-- 设备 -->
      <div class="ub-f1 ubv" v-if="active1 == 'third'">
        <div class="ub">
          <div class="ub-f1" style="padding-right: 16px">
            <search-input v-model="search" style="width: 100%" :placeholder="$t('company_member_jshsbmc')" @fetch="tabClick()"></search-input>
          </div>
          <el-button
            v-if="funcView.user_edit"
            :disabled="!selectedRow.userId"
            style="padding: 0 13px !important"
            type="warning"
            circle
            icon="icon icon-bianji"
            @click="editUser(selectedRow.userId, 3)"
          ></el-button>
        </div>
        <div class="user-device ub-f1">
          <custom-table :data="deviceList" tableCode="portal_companyDevice" height="100%"></custom-table>
        </div>
        <div class="table-page">
          <custom-pagination :total="totalRows1" :page="formSearch1.pageNum" :size="formSearch1.pageSize" :sizes="[]" @change="onPageDeviceChange"></custom-pagination>
        </div>
      </div>
    </div>
    <!-- 密码重置 -->
    <reset-pwd-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false"></reset-pwd-dialog>
    <!-- 用户弹窗 -->
    <company-user-dialog v-if="dialogVisible" :model="dialogModel" @close="successUser"></company-user-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetPwdDialog from './children/reset_pwd_dialog';
import companyUserDialog from './children/company_user_dialog.vue';

// i18n-lang-component
// company_member_yglb: 员工列表// company_member_geng_duo: 更多// company_member_zhong_zhi_mi_ma: 重置密码// company_member_ygxmdlzhlxdhyx: 员工姓名/登录账号/联系电话/邮箱// company_member_bu_men: 部门// company_member_bmmc: 部门名称// company_member_gang_wei: 岗位// company_member_gwmc: 岗位名称// company_member_she_bei: 设备// company_member_jshsbmc: 机身号/设备名称// company_member_nqdyqyxzdygm: 您确定要启用选中的员工吗?// company_member_nqdyjyxzdygm: 您确定要禁用选中的员工吗?// company_member_nqdyqygygm: 您确定要启用该员工吗?// company_member_nqdyjygygm: 您确定要禁用该员工吗？// company_member_xin_zeng_yong_hu: 新增用户// company_member_bian_ji_yong_hu: 编辑用户// company_member_zhong_zhi_mi_ma_1: 重置密码

export default {
  name: 'company_member',
  components: { companyUserDialog, resetPwdDialog },
  data() {
    return {
      active: '',
      active1: '',
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,
      },
      selectedRow: {},
      tableSelect: [],
      userList: [],
      totalRows: 0,

      userDepartmentList: [],
      userRoleList: [],
      formSearch1: {
        userId: '',
        search: '',
        pageSize: 50,
        pageNum: 1,
        productCode: '',
        orgType: '',
        orgName: '',
        projectName: '',
        contractNo: '',
      },
      search: '',
      deviceList: [],
      totalRows1: 0,

      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
    };
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_company_member');
    this.getUserPage();
    this.getFuncView();
  },
  methods: {
    i18nCallback() {
      this.active = 'first';
      this.active1 = 'first';
    },
    // 获取用户列表
    getUserPage: function () {
      this.$getJSON(apis.UserPage, this.formSearch).then((res) => {
        this.onCurrentRow();
        this.userList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.onCurrentRow();
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getUserPage();
    },
    // 批量修改用户状态弹窗
    setUserStatus: function (status) {
      if (status) {
        this.$showConfirm(this.$t('company_member_nqdyqyxzdygm'))
          .then(() => {
            const ids = this.tableSelect.map(t => t.userId);
            this.changeUserStatus(ids, 1);
          })
          .catch(() => {});
      } else {
        this.$showConfirm(this.$t('company_member_nqdyjyxzdygm'))
          .then(() => {
            const ids = this.tableSelect.map(t => t.userId);
            this.changeUserStatus(ids, 2);
          })
          .catch(() => {});
      }
    },
    // 修改用户状态弹窗
    setItemUserStatus: function (id, status) {
      if (status) {
        this.$showConfirm(this.$t('company_member_nqdyqygygm'))
          .then(() => {
            this.changeUserStatus([id], 1);
          })
          .catch(() => {});
      } else {
        this.$showConfirm(this.$t('company_member_nqdyjygygm'))
          .then(() => {
            this.changeUserStatus([id], 2);
          })
          .catch(() => {});
      }
    },
    // 修改用户状态(1激活，2.禁用， 3.删除)
    changeUserStatus: function (ids, state) {
      this.$postJSON(apis.UserState, { ids: ids, state: state }).then(() => {
        this.$message({
          message: this.$t('com_handle_success'),
          type: 'success',
        });
        this.getUserPage();
      });
    },
    // 切换分页
    changePage: function ({ page, size }) {
      this.formSearch.pageSize = size;
      this.formSearch.pageNum = page;
      this.getUserPage();
    },
    // 选中行
    onCurrentRow: function (row) {
      this.selectedRow = row || {};
      this.tabClick();
    },
    // 新增用户
    addUser() {
      this.dialogModel = {
        type: 'add',
        title: this.$t('company_member_xin_zeng_yong_hu'),
        data: {},
      };
      this.dialogVisible = true;
    },
    // 编辑用户
    editUser(userId, step) {
      this.dialogModel = {
        type: 'edit',
        title: this.$t('company_member_bian_ji_yong_hu'),
        userId: userId,
        step: step,
      };
      this.dialogVisible = true;
    },
    // 用户成功
    successUser(refresh) {
      this.dialogVisible = false;
      if (refresh) {
        this.getUserPage();
      } else {
        this.tabClick();
      }
    },
    // 重置密码
    resetPassword: function (userId) {
      this.dialogModel1.title = this.$t('company_member_zhong_zhi_mi_ma_1');
      this.dialogModel1.data = userId;
      this.dialogVisible1 = true;
    },
    // 侧边tab切换
    tabClick: function (init) {
      if (!this.selectedRow.userId) {
        this.search = '';
        this.userDepartmentList = [];
        this.userRoleList = [];
        this.deviceList = [];
        this.totalRows1 = 0;
        return;
      }
      if (init) {
        this.search = '';
      }
      if (this.active1 === 'first') {
        this.getUserDepartmentList();
      }
      if (this.active1 === 'second') {
        this.getUserRolePage();
      }
      if (this.active1 === 'third') {
        this.formSearch1.pageNum = 1;
        this.getUserDevice();
      }
    },
    // 获取用户组织列表(分页)
    getUserDepartmentList: function () {
      this.$getJSON(apis.UserDepartmentPage, {
        search: this.search,
        userId: this.selectedRow.userId,
        pageSize: 1000,
        pageNum: 1,
      }).then((res) => {
        this.userDepartmentList = res.data.list;
      });
    },
    // 获取用户岗位列表
    getUserRolePage: function () {
      this.$getJSON(apis.UserRolePage, {
        search: this.search,
        bizId: this.selectedRow.userId,
        isAssociated: 1,
        pageSize: 1000,
        pageNum: 1,
      }).then((res) => {
        this.userRoleList = res.data.list;
      });
    },
    // 用户设备
    getUserDevice: function () {
      this.formSearch1.search = this.search;
      this.formSearch1.userId = this.selectedRow.userId;
      this.$getJSON(apis.DevicePage, this.formSearch1).then((res) => {
        this.deviceList = res.data.list;
        this.totalRows1 = res.data.total;
      });
    },
    // 分页变更
    onPageDeviceChange: function ({ page, size }) {
      this.formSearch1.pageNum = page;
      this.formSearch1.pageSize = size || this.formSearch1.pageSize;
      this.getUserDevice();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.company-member-bd {
  background-color: #ffffff;
  min-height: 850px;
  border-radius: 16px;
  .user-wrap {
    padding: 24px 24px 0;
    width: 0;
    .title {
      height: 40px;
      line-height: 40px;
      font-weight: bold;
      color: #1a1a1a;
      font-size: 18px;
    }
    .action-hd {
      height: 88px;
      padding-top: 20px;
    }
  }
  .info-wrap {
    padding: 24px 24px 0;
    border-left: 1px solid #f8f9fa;
    .name {
      color: #00a0d9;
      line-height: 40px;
      height: 40px;
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 24px;
    }
  }
  .user-department,
  .user-role,
  .user-device {
    margin-top: 24px;
    & > ul li {
      height: 40px;
      line-height: 40px;
      padding: 0 16px;
      font-size: 14px;
      color: $--color-text-regular;
    }
    .el-table td {
      border-bottom: 1px solid #ebeef5;
    }
  }
}
</style>
